import "./LazyLoaderPage.scss";

const LazyLoaderPage = () => {
  return <section className="preloader-page" />;
};

export default LazyLoaderPage;
